import React from "react";
import Table from "../../../components/TableV2";
import TitleButtons from "../../../components/TitleButtons";
import { useSaidasSuprimentos } from "./saidas-servicoData";

const SuprimentosSaidas: React.FC = () => {
  const headers = [
    "OS",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Preço de Venda", // (antes: Custo Unitário)
    "R. Coleta",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useSaidasSuprimentos();

  const columnWidths = [
    "60px",
    "70px",
    "300px",
    "50px",
    "90px",
    "90px",
    "90px",
    "60px",
  ];

  return (
    <div>
      <TitleButtons
        fullBleedLine
        title="Coordenação - Baixas Serviços"
        buttons={[]}
      />
      <div
        style={{
          margin: "8px 0 6px",
          fontStyle: "italic",
          color: "#374151",
        }}
      >
        Atenção: não utilize o <b>Preço de Venda</b> como guia para futuros
        lançamentos/medições, pois o preço exibido é referente ao preço do
        produto durante a data de registro da O.S. Alterações futuras no preço
        não são consideradas. Para checagem de preços atualizados, consulte a
        sessão
        <b> Produtos</b>.
      </div>

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        isTableStandby
      />
    </div>
  );
};

export default SuprimentosSaidas;
